export const CRITICAL_LOAD_DEADLINE_MS = 300_000;

export const withCriticalLoadDeadline = <T>(
  operation: Promise<T>,
  label: string,
): Promise<T> =>
  new Promise<T>((resolve, reject) => {
    const timeoutId = globalThis.setTimeout(() => {
      reject(
        new Error(
          `Critical load exceeded ${CRITICAL_LOAD_DEADLINE_MS} milliseconds: ${label}`,
        ),
      );
    }, CRITICAL_LOAD_DEADLINE_MS);

    void operation.then(
      (value) => {
        globalThis.clearTimeout(timeoutId);
        resolve(value);
      },
      (error: unknown) => {
        globalThis.clearTimeout(timeoutId);
        reject(error);
      },
    );
  });
